import React from "react";

 const UserMaxSVG = () => {
  return (
 
      <svg
        width="145"
        height="145"
        viewBox="0 0 145 145"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0)">
          <path
            d="M145 72.5C145.013 82.3143 143.026 92.0283 139.161 101.05L138.921 101.603C132.383 116.476 121.047 128.727 106.725 136.397C92.4033 144.068 75.923 146.714 59.9198 143.912C59.4843 143.835 59.0496 143.755 58.6156 143.672C54.1312 142.803 49.7398 141.508 45.5013 139.805C44.8127 139.528 44.1292 139.241 43.4507 138.945C42.9874 138.743 42.524 138.535 42.065 138.321C29.5082 132.501 18.8768 123.213 11.424 111.551C3.97109 99.8892 0.00737153 86.3399 0 72.5C0 32.4598 32.4598 0 72.5 0C112.54 0 145 32.4598 145 72.5Z"
            fill="#6C63FF"
          />
          <path
            opacity="0.2"
            d="M59.9197 143.912C59.4843 143.835 59.0496 143.755 58.6156 143.672C58.3324 135.455 57.3607 118.589 54.0468 100.925C52.2343 91.2578 49.7182 81.348 46.2283 72.4893C45.0327 69.424 43.6671 66.4279 42.1379 63.5147C38.6116 56.8546 34.3345 51.2476 29.1479 47.4489L29.9116 46.4064C34.2251 49.5681 38.1018 54.0068 41.5416 59.7224C42.5733 61.4341 43.5643 63.2602 44.5145 65.2007C45.5334 67.277 46.5051 69.4813 47.4295 71.8136C48.0194 73.2979 48.5893 74.8337 49.1391 76.421C51.5329 83.3128 53.5677 91.1763 55.2437 100.011C55.6148 101.963 55.968 103.963 56.3033 106.011C58.9008 121.877 59.6837 136.547 59.9197 143.912Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M43.4505 138.945C42.9872 138.743 42.5239 138.535 42.0649 138.321C41.6166 133.451 40.7929 127.411 39.2871 121.678C38.6276 119.103 37.781 116.579 36.7539 114.127C35.0358 110.106 32.8115 106.687 29.9351 104.578L30.6987 103.538C33.7102 105.743 36.0332 109.228 37.8285 113.306C39.8512 117.9 41.2004 123.248 42.0992 128.357C42.7663 132.152 43.1867 135.817 43.4505 138.945Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M21.9349 47.4189C25.4993 47.4189 28.3888 44.5294 28.3888 40.965C28.3888 37.4006 25.4993 34.5111 21.9349 34.5111C18.3705 34.5111 15.481 37.4006 15.481 40.965C15.481 44.5294 18.3705 47.4189 21.9349 47.4189Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M24.0135 102.976C27.5779 102.976 30.4674 100.086 30.4674 96.5217C30.4674 92.9573 27.5779 90.0678 24.0135 90.0678C20.4491 90.0678 17.5596 92.9573 17.5596 96.5217C17.5596 100.086 20.4491 102.976 24.0135 102.976Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M47.5574 51.8056C46.1888 59.5269 49.21 66.5185 49.21 66.5185C49.21 66.5185 54.4502 60.9913 55.8188 53.2699C57.1873 45.5486 54.1661 38.5571 54.1661 38.5571C54.1661 38.5571 48.926 44.0843 47.5574 51.8056Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M26.1079 70.1344C33.4727 72.8274 40.8732 71.0992 40.8732 71.0992C40.8732 71.0992 36.3332 65.0047 28.9684 62.3117C21.6037 59.6187 14.2031 61.3469 14.2031 61.3469C14.2031 61.3469 18.7432 67.4413 26.1079 70.1344Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M24.859 119.332C30.0211 121.219 35.2156 119.988 35.2156 119.988C35.2156 119.988 32.0407 115.696 26.8786 113.809C21.7165 111.921 16.522 113.152 16.522 113.152C16.522 113.152 19.6969 117.444 24.859 119.332Z"
            fill="black"
          />
          <path
            d="M72.3512 88.5549C87.9612 88.5549 100.616 75.9005 100.616 60.2906C100.616 44.6806 87.9612 32.0263 72.3512 32.0263C56.7413 32.0263 44.0869 44.6806 44.0869 60.2906C44.0869 75.9005 56.7413 88.5549 72.3512 88.5549Z"
            fill="#D0CDE1"
          />
          <path
            d="M61.3101 81.9304C61.3101 81.9304 64.8431 98.7124 64.8431 100.479C64.8431 102.245 81.625 110.195 81.625 110.195L96.6404 107.545L101.94 91.6463C101.94 91.6463 93.1074 78.3974 93.1074 73.0978L61.3101 81.9304Z"
            fill="#D0CDE1"
          />
          <path
            d="M139.161 101.05L138.921 101.603C132.383 116.476 121.047 128.727 106.725 136.397C92.403 144.068 75.9226 146.714 59.9194 143.912C59.484 143.835 59.0493 143.755 58.6153 143.672C54.1308 142.803 49.7395 141.508 45.5009 139.805C44.8124 139.528 44.1289 139.241 43.4503 138.945C42.987 138.743 42.5237 138.535 42.0647 138.321C37.904 136.393 33.9359 134.075 30.2137 131.397L26.8633 121.678L28.7466 120.241L32.6204 117.283L36.7537 114.127L37.8284 113.306L54.0465 100.925L55.2434 100.011L63.6731 93.5765L63.6753 93.5744C63.6753 93.5744 72.7914 108.428 86.0409 104.012C99.2903 99.5953 99.0008 86.9314 99.0008 86.9314L139.161 101.05Z"
            fill="#2F2E41"
          />
          <path
            d="M47.8407 37.519C47.8407 37.519 56.8145 18.0757 74.0143 22.5626C91.2141 27.0495 100.936 33.7799 101.684 40.5102C102.431 47.2406 101.31 57.3361 101.31 57.3361C101.31 57.3361 99.4401 43.5015 87.475 46.4928C75.51 49.4841 56.8145 47.2406 56.8145 47.2406L53.8232 74.162C53.8232 74.162 50.4581 69.3012 46.719 72.2925C42.9799 75.2838 35.8756 43.5015 47.8407 37.519Z"
            fill="#2F2E41"
          />
          <path
            d="M45.5014 139.805C44.8128 139.528 44.1293 139.241 43.4508 138.945C42.9875 138.743 42.5242 138.535 42.0651 138.321C35.1839 135.13 28.8446 130.881 23.2773 125.73C25.2486 123.044 26.8637 121.678 26.8637 121.678H40.1132L42.0995 128.357L45.5014 139.805Z"
            fill="#2F2E41"
          />
          <path
            d="M127.555 99.5953L138.921 101.603C135.88 108.532 131.772 114.943 126.747 120.601L127.555 99.5953Z"
            fill="#2F2E41"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="145" height="145" fill="white" />
          </clipPath>
        </defs>
      </svg>
   
  );
};

export default UserMaxSVG;